import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProtectivePaletteCovering = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 100,
	viewBox: "0 0 80.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 80,
			height: 100,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 5.0 80.0 L 75.0 80.0 M 15.0 70.0 L 65.0 70.0 M 15.0 65.0 L 65.0 65.0 M 15.0 60.0 L 65.0 60.0 M 15.0 55.0 L 65.0 55.0 M 27.3 55.4 L 27.3 60.4 M 27.3 65.4 L 27.3 70.4 M 27.3 75.4 L 27.3 80.4 M 39.8 60.4 L 39.8 65.4 M 39.8 70.4 L 39.8 75.4 M 52.3 55.4 L 52.3 60.4 M 52.3 65.4 L 52.3 70.4 M 52.3 75.4 L 52.3 80.4 M 15.0 45.0 L 65.0 45.0 M 15.0 50.0 L 65.0 50.0 M 40.0 50.0 L 40.0 55.0 M 40.0 40.0 L 40.0 45.0 M 27.5 45.0 L 27.5 50.0 M 52.5 45.0 L 52.5 50.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 15,
			width: 70,
			height: 60,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15,
			y: 40,
			width: 50,
			height: 40,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgProtectivePaletteCovering;
